import React, { useMemo } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useTwgoldAuth } from "../contexts/useTwgoldAuth";
import {
  PUBLIC_PATHS,
  resolveDashboardPath
} from "../../../config/routes";

export const TwgoldProtectedRoute = ({
  children,
  allowedRoles = []
}) => {
  const { user, loading, isInitialized } = useTwgoldAuth();
  const location = useLocation();

  const isPublicPath = useMemo(
    () => PUBLIC_PATHS.includes(location.pathname),
    [location.pathname]
  );

  /* ================= LOADING ================= */
  if (!isInitialized) {
    return null; // 🔥 prevents flicker
  }
  
  if (loading) {
    return (
      <div className="twgold_loading">
        <div className="twgold_loading_spinner" />
      </div>
    );
  }

  /* ================= PUBLIC ================= */
  if (isPublicPath) {
    // Redirect logged-in user away from login page
    if (location.pathname === "/twgl&articles/login" && user) {
      return (
        <Navigate
          to={resolveDashboardPath(user.role)}
          replace
        />
      );
    }

    return children;
  }

  /* ================= WAIT FOR USER ================= */
  if (!user && !isPublicPath) {
    return (
      <Navigate
        to="/twgl&articles/login"
        state={{ from: location }}
        replace
      />
    );
  }

  /* ================= ROLE CHECK ================= */
  if (
    allowedRoles.length > 0 &&
    !allowedRoles.includes(user.role)
  ) {
    return (
      <Navigate
        to={resolveDashboardPath(user.role)}
        replace
      />
    );
  }

  /* ================= ACCESS GRANTED ================= */
  return children;
};